<template>
    <section>
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox float-e-margins">
                        <div class="ibox-title">
                            <h5>Customer Feedback </h5>
                        </div>
                        <div class="ibox-content">
                            <div v-if="!isFeedBackAlreadySaved">
                                <div class="row" v-for="(questions, questionIndex) in branchFeedbackAnswers" :key="questionIndex">
                                    <hr>
                                    <center><h2>{{questions.question}}</h2></center>
                                    <div v-if="questions.questionType==='emoticon'">
                                        <div class="col-md-3 col-sm-4 col-xs-3" v-for="(emoticon, emoticonIndex) in allEmoticons" :key="emoticonIndex">
                                            <center><img class="makeGray" :class="questionIndex + '_q_index'" @click="emoticonClick($event, questionIndex, emoticon, questions)" :src="getEmoticonURL(emoticon)" :value="emoticon" style='max-width: 50px; padding:5px;' :id="questionIndex + '_'+ emoticonIndex + '_'+ 'emoticons'" ></center>
                                        </div>
                                    </div>
                                    <div v-if="questions.questionType==='radio'">
                                        <div  v-for="(radioOptions, radioIndex) in feedbackQuestions[questionIndex].options" :key="radioIndex" :class="'col-xs-'+ 12/feedbackQuestions[questionIndex].options.length">
                                            <center><input type="radio" v-model="questions.answer" v-bind:value="radioOptions" name="options"> {{radioOptions}}</center>
                                        </div>
                                    </div>
                                    <div v-if="questions.questionType==='checkboxes'">
                                    <div class="checkbox text-center" v-for="(checkboxOptions, checkboxIndex) in feedbackQuestions[questionIndex].options" v-bind:key="'feedback_checkbox_'+checkboxIndex + Math.random()" :class="'col-xs-'+ 12/feedbackQuestions[questionIndex].options.length">
                                        <label>
                                            <input type="checkbox" v-on:click="checkboxClicked(questions, checkboxOptions, $event)"/> {{checkboxOptions}}
                                        </label>
                                    </div>                                    
                                    </div>
                                    <div v-if="questions.questionType==='comment'">
                                            <input type="text" v-model="questions.answer" placeholder="Type Some Comment Here" class="form-control callerNumberBox">
                                    </div>
                                    <div v-if="questions.questionType==='text'">
                                        <textarea class="form-control" v-model="questions.answer" id="text" placeholder="Type Some Text Here"></textarea>
                                    </div>
                                </div>
                                <br>
                                <button type="button" class="btn btn-primary" @click="submit()">Submit</button>
                            </div>
                            <div v-else>
                                <center>
                                    <h1><b>Feedback Has Been Saved. <br> Thank You</b></h1>
                                </center>
                            </div>                            

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import cryptoJs from 'crypto-js'
    export default {
        name: "PublicOrderFeedback",
        data() {
            return {
                isFeedBackAlreadySaved:false,
                orderId:'',
                order:null,
                feedbackQuestions:{},
                allEmoticons:["Dissatisfied", "Neutral", "Satisfied", "Awesome"],
                branchFeedbackAnswers:[],
                feedback:{
                    customerName:'NA',
                    customerPhone:'',
                    customerEmail:'',
                    customerAddress:null,
                    customerDOB:null,
                    hearAboutUs:'',
                    md5Hash:null,
                    averageScore:null,
                    dateAndTimeOfVisit:'',
                    waiters:null,
                    tables:null,
                    branchFeedbackAnswers:[],
                    orderId:null
                }
            };
        },
        mounted: async function () {
            let encOrderId='';
            let encKey="ZGVsaXZlcnltb25zdGVycw=="; //deliverymonsters
            $("body").addClass("gray-bg");
           let parsedBase64Key = cryptoJs.enc.Base64.parse(encKey);
            console.log("parsed key: ", parsedBase64Key.toString());
            if(this.$route.query.order_id !== undefined){
                encOrderId= this.$route.query.order_id.replace(/\s/g, "+")
            }
            this.orderId= cryptoJs.AES.decrypt(encOrderId, parsedBase64Key, {
                mode: cryptoJs.mode.ECB,
                padding: cryptoJs.pad.Pkcs7
            }).toString(cryptoJs.enc.Utf8);              
            await this.checkFeedBackAlreadySaved()
        },
        methods: {          
            checkFeedBackAlreadySaved: async function(){
                const resp= await this.$http.get(this.$store.state.mainAppURL + "feedback/is_feedback_already_saved/" + this.orderId);
                console.log(resp.data);
                this.isFeedBackAlreadySaved= resp.data;
                if(!this.isFeedBackAlreadySaved){
                    this.fetchBranchFeedbackQuestions();
                }
            },
            fetchBranchFeedbackQuestions: function(){
                this.$http.get(this.$store.state.mainAppURL + "feedback/find_feedback_questions_by_order_id/" + this.orderId).then(resp=>{
                    this.feedbackQuestions= resp.data.feedbackQuestions;
                    for(let question of this.feedbackQuestions){
                        let answer={question: question.question, questionType: question.type, answer: ''}
                        this.branchFeedbackAnswers.push(answer);
                    }
                    console.log(this.branchFeedbackAnswers);
                });
            },
            getEmoticonURL: function(emoticon){
                const basePath= '/img/emoji/'
                switch(emoticon){
                    case 'Dissatisfied':
                        return basePath + 'mad.png'
                    case 'Neutral':
                        return basePath + 'confused.png'
                    case 'Satisfied':
                        return basePath + 'smiling.png'
                    case 'Awesome':
                        return basePath + 'happy.png'
                }
            },
            emoticonClick: function(event, questionIndex, emoticon, question){
                question.answer= emoticon;
                $("." + questionIndex + "_q_index").addClass('makeGray');
                $("#"+event.target.id).removeClass('makeGray')

            },
            checkboxClicked: function(question, option, e){
                if(e.target.checked){
                    if(question.answer===''){
                        question.answer=[];
                        question.answer.push(option);
                    }else{
                        question.answer.push(option);
                    }
                }else{
                    let index= question.answer.indexOf(option)
                    if(index>-1){
                        question.answer.splice(index, 1)
                    }
                }
            },
            submit: function(){
                for(let feedbackAnswer of this.branchFeedbackAnswers){
                    if(feedbackAnswer.answer===''){
                        feedbackAnswer.answer='N/A'
                    }
                    if(feedbackAnswer.questionType==='checkboxes'){
                        feedbackAnswer.answer= feedbackAnswer.answer.toString();
                    }
                }
                this.feedback.dateAndTimeOfVisit= new Date();
                this.feedback.branchFeedbackAnswers= this.branchFeedbackAnswers;
                this.$http.post(this.$store.state.mainAppURL + "feedback/public_response/" + this.orderId, this.feedback).then(resp=>{
                    this,this.isFeedBackAlreadySaved=true;
                    swal("Success!","Your Feedback Has Been Saved. Thank You.", "success")
                })
            }
        }
    }
</script>

<style scoped>
section {
    margin: 0px 5% 0px;
}
.makeGray{
    filter: grayscale(100%);
}
</style>
